module.exports = __webpack_public_path__ + "static/img/book16.603c840.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book16.jpg
// module id = EDYr
// module chunks = 1